import React from 'react';
import { Modal, ModalContent, Button } from '@heroui/react';
import { Icon } from '@iconify/react';

const CommentErrorModal = ({ isOpen, onClose, errorType = 'generic' }) => {
  const getErrorContent = () => {
    switch (errorType) {
      case 'EMAIL_NOT_VERIFIED':
        return {
          icon: 'solar:shield-warning-bold',
          title: 'Email Verification Required',
          message: (
            <>
              Please verify your email first to comment.
              <br />
              Check your inbox for the verification link or click 'Verify Email' in your profile menu.
            </>
          ),
        };
      default:
        return {
          icon: 'solar:close-circle-bold',
          title: 'Failed to Post',
          message: (
            <>
              Failed to post reply. Please try again.
            </>
          ),
        };
    }
  };

  const content = getErrorContent();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      placement="center"
      backdrop="blur"
      size="sm"
      classNames={{
        backdrop: "bg-gradient-to-t from-zinc-900 to-zinc-900/10 backdrop-opacity-20",
      }}
    >
      <ModalContent className="bg-white dark:bg-gray-800">
        {(onClose) => (
          <div className="flex flex-col items-center gap-6 p-8">
            {/* Icon */}
            <div className="w-20 h-20 rounded-full flex items-center justify-center bg-gray-100 dark:bg-gray-700">
              <Icon
                icon={content.icon}
                className={`text-5xl ${
                  errorType === 'EMAIL_NOT_VERIFIED'
                    ? 'text-yellow-600 dark:text-yellow-400'
                    : 'text-red-600 dark:text-red-400'
                }`}
              />
            </div>

            {/* Title */}
            <h3 className="text-2xl font-bold text-center text-gray-900 dark:text-gray-100">
              {content.title}
            </h3>

            {/* Message */}
            <p className="text-sm text-center leading-relaxed text-gray-600 dark:text-gray-300 px-2">
              {content.message}
            </p>

            {/* Action Button */}
            <Button
              onPress={onClose}
              color="primary"
              className="w-full font-semibold"
              size="lg"
            >
              Close
            </Button>
          </div>
        )}
      </ModalContent>
    </Modal>
  );
};

export default CommentErrorModal;
